import { Box, Typography, useMediaQuery } from "@mui/material";

const BuilderTItle = ({ title, rightElement }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "48px", // var(--Spacing-spacing-48, 48px)
        paddingLeft: "4px", // var(--Spacing-spacing-4, 4px)
        alignItems: "center",
        gap: "8px", // var(--Spacing-spacing-8, 8px)
        alignSelf: "stretch",
        borderRadius: "8px", // var(--Corner-radius-corner-radius-small)
        borderBottom: "1px solid #D7E5F8", // var(--Tokens-Border-Default)
        flexDirection: isMobile ? "column" : "",
      }}
    >
      <Box
        sx={{
          display: "flex",
          paddingRight: "8px", // var(--Spacing-spacing-8, 8px)
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "2px", // var(--Spacing-spacing-2, 2px)
          flex: "1 0 0",
        }}
      >
        <Typography
          sx={{
            overflow: "hidden",
            color: "var(--Tokens-Text-Primary, #3A3A3A)",
            fontFeatureSettings: "'liga' off, 'clig' off",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
            fontSize: "var(--Font-Size-H5, 24px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-H5, 32px)",
          }}
          noWrap
        >
          {title}
        </Typography>
      </Box>
      {rightElement}
    </Box>
  );
};

export default BuilderTItle;
